import React from 'react';
import PropTypes from 'prop-types';

import Full from './full';
import deliveryOptionType from '../types/delivery-option-type';
import { useIsBelowViewport } from '../hooks/use-is-below-viewport';
import WalmartPlusPromotion from '../walmart_plus_promotion';

export default function Totalizer({
  onRef,
  freeShippingEnabled,
  freeShippingAssetUrl,
  freeShippingThreshold,
  homeDeliveryItemsPrice,
  deliveryOptions,
  checkoutBlocker,
  price,
  quantity,
  shippingCost,
  selectedDeliveryOptions,
  crossSellItemCheckOutClick,
  promotionMessageKey,
}) {
  const { containerRef, isBelowViewport, height } = useIsBelowViewport();
  const promotionMessage = (
    <WalmartPlusPromotion promotionMessageKey={promotionMessageKey} />
  );

  return (
    <div
      className="totalizer-wrapper"
      style={{ minHeight: `${height}px` }}
      ref={containerRef}>
      <div
        className={`total-and-action card shadow-sm${isBelowViewport ? ' totalizer__fixed-bottom' : ''}`}
        id="totalizer"
        data-test-id="totalizer">
        <div className="card-body" data-test-id="totalizer-full">
          <Full
            ref={onRef}
            price={price}
            quantity={quantity}
            shippingCost={shippingCost}
            checkoutBlocker={checkoutBlocker}
            deliveryOptions={deliveryOptions}
            freeShippingEnabled={freeShippingEnabled}
            freeShippingAssetUrl={freeShippingAssetUrl}
            freeShippingThreshold={freeShippingThreshold}
            homeDeliveryItemsPrice={homeDeliveryItemsPrice}
            selectedDeliveryOptions={selectedDeliveryOptions}
            crossSellItemCheckOutClick={crossSellItemCheckOutClick}
            promotionMessage={promotionMessage}
          />
        </div>
      </div>
      {promotionMessageKey && (
        <div className="d-none d-md-block mt-3">
          <WalmartPlusPromotion promotionMessageKey={promotionMessageKey} fullMessage />
        </div>
      )}
    </div>
  );
}

Totalizer.propTypes = {
  onRef: PropTypes.func,
  simpleTotalizer: PropTypes.bool,
  freeShippingEnabled: PropTypes.bool,
  freeShippingAssetUrl: PropTypes.string,
  freeShippingThreshold: PropTypes.number,
  homeDeliveryItemsPrice: PropTypes.number,
  deliveryOptions: PropTypes.arrayOf(deliveryOptionType),
  checkoutBlocker: PropTypes.number,
  price: PropTypes.number,
  quantity: PropTypes.number,
  shippingCost: PropTypes.number,
  selectedDeliveryOptions: PropTypes.arrayOf(deliveryOptionType),
  crossSellItemCheckOutClick: PropTypes.func,
  promotionMessageKey: PropTypes.string,
};
